import React from 'react';
import classNames from 'classnames';

import Styles from './SummaryTile.styles';

interface Props {
  className?: string;
  price?: string // already formatted
  nextBillDate?: string,
  nextBillDateLabel: string,
}

export const PlanDetails: React.FC<Props> = ({
  className, children, price, nextBillDate, nextBillDateLabel,
}) => (
  <div
    className={classNames(className, Styles.info)}
    data-qa="summary-tile-plan-details"
  >
    {children && (
      <div>
        {children}
      </div>
    )}
    <div className="text-gray-600">
      {price && `${price} / month `}
      {nextBillDate && `(${nextBillDateLabel} - ${nextBillDate})`}
    </div>
  </div>
);

PlanDetails.defaultProps = {
  nextBillDateLabel: 'Next bill day',
};
